<template>
  <div class="w-full h-full flex flex-col">
    <tabs-wrapper
      contentClass="overflow-y-scroll md:px-8 md:pt-4"
      class="h-full w-full">
        <template #header-end-0 v-if="canEdit">
        <Button label="הוספת שירות" icon="pi pi-plus" size="small" @click="addNewService" />
      </template>
      <tab title="שירותים וטיפולים" description="השירותים שמוצעים ללקוחות בעמוד ההזמנה" class="h-full w-full">
        <Services />
      </tab>
        <template #header-end-1 v-if="canEdit">
        <Button label="הוספת שירות" icon="pi pi-plus" size="small" @click="addNewComplementaryService" />
      </template>
        <tab title="שירותים משלימים" description="שירותים נוספים שניתן להוסיף בתהליך ההזמנה (אפסל)" class="h-full w-full" v-if="canManageOthers">
        <UpSellServices />
      </tab>
        <template #header-end-2 v-if="canEdit">
        <Button label="הוספת שירות" icon="pi pi-plus" size="small" @click="addNewHiddenService" />
      </template>
        <tab title="שירותים נסתרים" description="שירותים פנימיים שלא מוצגים ללקוח בעמוד ההזמנה" class="h-full w-full" v-if="canManageOthers">
        <PrivateServices />
      </tab>
    </tabs-wrapper>
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import { useAdminStore } from '@app/stores';
import { AdminRouteNames } from '@app/router/route-names';
import { computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import ConfirmDialog from 'primevue/confirmdialog';
import Tab from './components/admin-tabs/Tab.vue';
import AddOrEditService from '@app/components/admin/modals/AddOrEditService.vue';
import { ServiceType } from '@torim-app/types';
import { useDrawer } from '@torim-app/shared-components';
import { useHeaderAction } from '@app/composables/header-action';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const route = useRoute();
const { openDrawer, closeDrawer } = useDrawer();
const { setHeaderAction } = useHeaderAction();

trackEvent('business_configurations_viewed');
adminStore.setPage(AdminRouteNames.BusinessConfigurations);

const isMainClient = computed(() => adminStore.getMainClient);
const canManageOthers = computed(() => adminStore.getCanManageOthers);
const canEdit = computed(() => adminStore.getCanEdit);

const addNewService = () => {
  trackEvent('add_service_clicked');
  openDrawer(AddOrEditService, {
    serviceType: ServiceType.REGULAR,
    service: undefined,
    mode: 'create',
    onClose: closeDrawer
  }, { title: 'הוספת שירות חדש' });
};

const addNewComplementaryService = () => {
  trackEvent('add_service_clicked', { source: 'business_config', service_type: 'complementary' });
  openDrawer(AddOrEditService, {
    serviceType: ServiceType.COMPLEMENTARY,
    service: undefined,
    mode: 'create',
    onClose: closeDrawer
  }, { title: 'הוספת שירות משלים חדש' });
};

const addNewHiddenService = () => {
  trackEvent('add_service_clicked', { source: 'business_config', service_type: 'hidden' });
  openDrawer(AddOrEditService, {
    serviceType: ServiceType.HIDDEN,
    service: undefined,
    mode: 'create',
    onClose: closeDrawer
  }, { title: 'הוספת שירות נסתר חדש' });
};

// The mobile header "+" adds a service of whatever type the active tab shows
// (tabs are driven by the ?tab query param)
const updateHeaderAction = () => {
  if (!canEdit.value) return;
  const tab = Number(route.query.tab ?? 0);
  if (tab === 1) {
    setHeaderAction({ icon: 'pi-plus', onClick: addNewComplementaryService, ariaLabel: 'הוספת שירות משלים' });
  } else if (tab === 2) {
    setHeaderAction({ icon: 'pi-plus', onClick: addNewHiddenService, ariaLabel: 'הוספת שירות נסתר' });
  } else {
    setHeaderAction({ icon: 'pi-plus', onClick: addNewService, ariaLabel: 'הוספת שירות' });
  }
};
onMounted(updateHeaderAction);
watch([() => route.query.tab, canEdit], updateHeaderAction);
</script>

<style scoped lang="scss">

</style>
